module.exports = __webpack_public_path__ + "assets/images/glucose_y.c0137456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/glucose_y.png
// module id = 722
// module chunks = 1